module.exports = {"amount":"Amount","amount_enter":"Enter amount","amount_between_hint":"Must be between {{min}} {{currency}} and {{max}} {{currency}}","amount_max_hint":"Max input allowed is {{max}} {{currency}}","amount_min_hint":"Min input allowed is {{min}} {{currency}}","duplicated":"Cannot be the same as the details you already provided"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/amount.json
// module id = 509
// module chunks = 245 990